import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';


const PREFIX = 'ClassroomCheckList';

const classes = {
    subtitle: `${PREFIX}-subtitle`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.subtitle}`]: {
        fontSize: theme.typography.pxToRem(13), /*fontsize of the default option "nunguna" */
        textOverflow: 'ellipsis',
        width:'300px',
        overflow:'hidden',
        whiteSpace:'nowrap'
}
}));


function ClassroomCheckList(props) {

    const {
        value,
        open,
        handleClickListItem,
        handleOk,
        handleChange,
        required,
        checkAll,
        checkboxes,
        handleChangeAll,
        height
    } = props;
    const theme = useTheme();

    const formControlLabelArray = [];
    for (var i = 0; i < checkboxes.length; i++) {
        formControlLabelArray.push(
            <FormControlLabel
                key={i}
                control={<Checkbox id={checkboxes[i].id} sx={{marginLeft: 2.5}} checked={checkboxes[i].checked} onChange={handleChange} value={checkboxes[i].name} />}
                label={<Typography sx={{fontSize: theme.typography.pxToRem(14)}}>{checkboxes[i].name}</Typography>}
            />
        )
    }

    var requiredAsterisk = null;
    var secondaryText = value;
    if (required) {
        requiredAsterisk = <Box color="error.main"> *</Box>;
        if (value === "Ninguna") {
            secondaryText = <Typography component={'div'} className={classes.subtitle}>
                <Box color="error.main">{value}</Box>
            </Typography>;
        }
    }
    var maxHeight = height < 435 ? '95%' : 435;
    return (
        <Root>
            <Dialog
                onClose={(event, reason) => {
                    //disable backdrop click
                }}
                disableEscapeKeyDown
                maxWidth="xs"
                aria-labelledby="confirmation-dialog-title"
                open={open}
                sx={{
                    '& .MuiPaper-root': {
                        width: '80%',
                        maxHeight: maxHeight,
                    },
                }}
            >
                <DialogTitle id="confirmation-dialog-title">
                    <Typography fontWeight="fontWeightMedium" component={'div'} variant="body1">Selecciona tipo(s) de sala</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox id="all"  checked={checkAll} onChange={handleChangeAll} value="all" />}
                            label={<Typography fontWeight="fontWeightMedium" component={'div'} sx={{fontSize: theme.typography.pxToRem(13)}}>Todas</Typography>}
                        />
                            {formControlLabelArray}
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOk} color="primary">
                        Aplicar
                    </Button>
                </DialogActions>
            </Dialog>
            <ListItemButton
                button
                divider
                aria-haspopup="true"
                aria-controls="salas-menu"
                aria-label="salas"
                onClick={handleClickListItem}
                role="listitem"
                selected={open}
                sx={{
                    paddingLeft: 1.25,
                    paddingRight: 1.25,
                }}
            >
                <ListItemText primary={
                    <Typography component={'div'} sx={{fontSize: theme.typography.pxToRem(14)}}>
                        <div style={{ display: "flex" }}>
                            Seleccione tipo(s) de sala {requiredAsterisk}
                        </div>
                    </Typography>
                } secondary={secondaryText} />
            </ListItemButton>
        </Root>
    );
}


export default ClassroomCheckList;